var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowBanner)?_c('banner',{attrs:{"color-scheme":"alert","banner-message":_vm.bannerMessage,"action-button-label":_vm.actionButtonMessage,"has-action-button":""},on:{"click":_vm.routeToBilling}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }